// extracted by mini-css-extract-plugin
module.exports = {"columnNumberTenant":"profilesTable_columnNumberTenant__1zu1x"};